export const FORCE_ACTIVATION_SUCCESS = 'Successfully Force Activate';
export const FORCE_ACTIVATION_FAILED = 'Failed to do Force Activation';
